import { useEffect } from "react"
import VenueMasterForm from "./VenueMasterForm"


const VenueMaster = ({ open }) => {
    useEffect(() => {
        document.title = 'Venue Master'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <VenueMasterForm />
        </main>
    )
}
export default VenueMaster